import { isDatesEqualInUTC } from '@epicuro-next/utilities';

import { RequestedQuantity } from './requested-quantity';

// it will merge items that have same requested date and make a sum of quantities for it
export const mergeSplitQuantitiesByDate = (
  requestedQuantities: RequestedQuantity[],
): RequestedQuantity[] => {
  return requestedQuantities
    .reduce((mergedItems, currentItem) => {
      const mergedItem = mergedItems.find((item) =>
        isDatesEqualInUTC(
          item.requestedDeliveryDate,
          currentItem.requestedDeliveryDate,
        ),
      );
      if (!mergedItem) {
        return [...mergedItems, currentItem];
      }
      return [
        ...mergedItems.filter((item) => item !== mergedItem),
        {
          ...mergedItem,
          requestedQuantity:
            mergedItem.requestedQuantity + currentItem.requestedQuantity,
        },
      ];
    }, [] as RequestedQuantity[])
    .filter((item) => item.requestedQuantity > 0)
    .sort((a, b) => {
      if (a.requestedDeliveryDate > b.requestedDeliveryDate) return 1;
      if (a.requestedDeliveryDate < b.requestedDeliveryDate) return -1;
      return 0;
    });
};
